<template>
  <div class="page-container">
    <div class="filter-container" />
    <div class="page-title">
      {{ $t('menu.batch_payment_details') }}
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
        class="tableContainer"
      >

        <el-table-column :label="$t('customerService.reference')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.batch_no }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.submit_quantity')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.submit }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.success_quantity')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.success }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.pending_quantity')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.pending}}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.fail_quantity')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.failed }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.total_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.total_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.create_time')" align="center">
          <template slot-scope="scope">
            {{ scope.row.created_time }}
          </template>
        </el-table-column>


        <el-table-column :label="$t('components.operation')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span>
              </div>
              <svg-icon class-name="icon-function " icon-class="operation-detail" @click="onClickDetailBtn(scope.row.batch_no)" />
            </el-tooltip>

            <el-tooltip placement="top">
              <div slot="content">
                <span> {{ $t('components.download') }}</span>
              </div>
              <svg-icon class-name="icon-function operation-download" icon-class="operation-download" @click="onClickDowmloadBtn(scope.row)" />
            </el-tooltip>

          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>
  </div>
</template>

<script>

import { fetchDisbursementAllRefernceData, fetchDisbursementAllRefernceDataDownload } from '@/api/online-transaction/online-transaction'
import { poTransStatusMap } from '@/utils/maps'
import { filterEmptyAttr, exportXlsx } from '@/utils/common'
export default {
  name: 'Approved',
  components: {
    Paginator: () => import('@/views/components/Paginator')
  },
  data() {
    return {
      multipleSelection: [],
      tableData: [],
      listLoading: false,
      submiting: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false
    }
  },
  computed: {
    getPOTransactionStatusType() {
      return function(value) {
        return poTransStatusMap(value).type
      }
    },
    getPOTransactionStatusMap() {
      return function(value) {
        return poTransStatusMap(value).label
      }
    }
  },
  created() {
    this.getAllReferenceInfo()
    const { page } = this.$route.query
    this.listQuery.page = page
  },
  methods: {
    getAllReferenceInfo(otherParams) {
      this.listLoading = true
      const params = this.getParams(otherParams)
      fetchDisbursementAllRefernceData(params).then(res => {
        if (res.code === 10000) {
          const { total, list = [] } = res.data
          this.listQuery.total = total
          this.listQuery.page = params.page ? params.page : 1
          this.tableData = list
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      let params = { ...otherParams }
      params = this.$commonFn.filterEmptyAttr(params)
      return params
    },

    onClickDetailBtn(batch_no) {
      this.$router.push({ name: 'Batch_Disbursement_Reference_Detail', params: { id: batch_no } ,query:{
        page: this.listQuery.page
      }})
    },
    onClickDowmloadBtn(row) {
      const params = {
        batch_no: row.batch_no
      }
      fetchDisbursementAllRefernceDataDownload(params).then(res => {
        if (res.code === 10000) {
          //this.$message.success(res.data.msg)
          if (res.data.is_async) {
            this.$store.commit('app/SET_SHOW_DOWNLOAD_LIST', true)
          }
        }
      }).finally(() => {
      })
    },
    handleXlsxData(data = []) {
      const rows = [[
        this.$t('customerService.reference'),
        this.$t('customerService.transaction_id'),
        this.$t('merchantAccount.recipient_channel'),
        this.$t('send_pagements.recipient_account_number'),
        this.$t('merchantAccount.recipient_name'),
        this.$t('customerService.email_address'),
        this.$t('components.amount'),
        this.$t('merchantAccount.transaction_status'),
        this.$t('data.remark'),
        this.$t('merchantAccount.create_time'),
        this.$t('merchantAccount.complete_time')
      ]]

      const toThousandFilter = this.$options.filters['toThousandFilter']
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((tr) => {
          rows.push([
            tr.reference_batch_no,
            tr.transaction_id,
            tr.code,
            tr.account_no,
            tr.account_name,
            tr.email,
            tr.amount && Number(tr.amount),
            this.getPOTransactionStatusMap(tr.transaction_status),
            tr.remark,
            tr.transaction_create_time,
            tr.transaction_return_time
          ])
        })
      }
      return Promise.resolve(rows)
    },
    onClickPaginator() {

      this.getAllReferenceInfo(this.listQuery)
    }
  }

}
</script>

<style lang="scss" scoped>
.approved{
   background-color: #fff;
   .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px;
  }
  .btn-container{
    display: flex;
    justify-content: flex-end;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
 .mb-10{
    margin-bottom: 10px;
  }
}

</style>
